import { AxiosResponse } from 'axios';

import { HydraListResponse, LoadListDataParams } from 'hooks/useListData';
import { IDistribution, IDistributionData } from 'types/distribution.types';
import api from 'utils/apiClient';

export const loadDistributions = ({
  pageSize,
  ...params
}: LoadListDataParams): Promise<AxiosResponse<HydraListResponse<IDistribution>>> => {
  return api.get('/announcements', { params: { ...params, itemsPerPage: pageSize } });
};

export const createDistribution = (data: IDistributionData) => {
  return api.post('/announcements', data, {
    headers: {
      'Content-Type': 'application/ld+json',
    }
  });
};

export const editDistribution = ({ id, ...data }: IDistribution) => {
  return api.patch(`/announcements/${id}/edit`, data, {
    headers: {
      'Content-Type': 'application/ld+json',
    }
  });
};
